import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { Flex } from '@updater/ui-uds';
import { useAddress, useStore } from 'hooks';
import { useEnvironment } from 'services';
import type { Address } from 'types';
import { SingleLineAddressInput } from 'components/SingleLineAddressInput';
import { ValidatedAddress } from 'hooks/address';

export const AddressEntryForm: React.FC<{
  onSubmit: (address: Address) => void;
}> = ({ onSubmit }) => {
  const { smartyStreetsAPIKey } = useEnvironment();
  const address = useAddress();
  const [setAddress] = useStore(useShallow((store) => [store.setAddress]));

  const handleAddressComplete = useCallback(
    ({ validation: _v, ...addressOnly }: ValidatedAddress) => {
      setAddress(addressOnly);
      onSubmit(addressOnly);
    },
    [onSubmit, setAddress]
  );

  return (
    <Flex
      width="100%"
      marginY="none"
      marginX="auto"
      flexDirection="column"
      gap="s"
    >
      <SingleLineAddressInput
        smartyStreetsAPIKey={smartyStreetsAPIKey}
        onComplete={handleAddressComplete}
        initialAddress={address}
      >
        <SingleLineAddressInput.Default />
      </SingleLineAddressInput>
    </Flex>
  );
};
